import { WizardStep } from "./wizard-step";

export class WizardOption {
  title: string = "";
  subtitle: string = "";
  imgSrc: string = "";
  iconFontSet: string = "";
  iconName: string = "";
  iconSvgName: string = "";
  isSelected: boolean = false;
  step: WizardStep = new WizardStep();
  tooltipText: string = "";
  isSingleOption: boolean = false;
}
